import { render, staticRenderFns } from "./liste_formations.vue?vue&type=template&id=224dc89f&"
import script from "./liste_formations.vue?vue&type=script&lang=js&"
export * from "./liste_formations.vue?vue&type=script&lang=js&"
import style0 from "./liste_formations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports